import { apiClient } from "./apiClient";

/**
 * The caller's own referral team.
 *
 * There is deliberately no referrer parameter to pass. The backend derives
 * the identity from the authenticated session, so nothing this function
 * could send would change whose team comes back — `status` and `search` only
 * narrow a result set the server has already restricted to the caller.
 *
 * @param {{status?: string, search?: string}} [filters]
 * @param {{signal?: AbortSignal}} [options]
 */
export async function fetchMyTeam(filters = {}, { signal } = {}) {
  const params = {};
  if (filters.status) params.status = filters.status;
  if (filters.search) params.search = filters.search;

  const response = await apiClient.get("/api/my-team", { params, signal });
  return response.data;
}
